import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import dayjs from 'dayjs';
export default {
  name: 'pay_charge_order',
  data: function data() {
    return {
      dayjs: dayjs,
      currentUser: localStorage.getItem('userId'),
      pageConfig: {
        editPageName: '充值订单',
        queryFunName: 'chargeOrderQueryJoinProjectAndUser',
        detailFunName: 'chargeOrderDetail'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        projectName: null,
        state: 'end',
        sortField: 'create_time'
      },
      formData: {},
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {}
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  methods: {
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    detail: function detail(data) {
      var _this = this;
      this.$api[this.pageConfig.detailFunName](data.id).then(function (res) {
        _this.initFormData(res.data);
        _this.formData.userNickname = data.userNickname;
        _this.formData.userPhone = data.userPhone;
        _this.formData.userImage = data.userImage;
        _this.formData.projectName = data.projectName;
        _this.editDialogTitle = _this.pageConfig.editPageName + '明细';
        _this.editDialogShow = true;
      });
    },
    query: function query() {
      var _this2 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this2.tableData = res.data || [];
        _this2.totalCount = res.count;
        _this2.queryLoading = false;
      });
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};